import StoreContainer from 'store/container';

const getAuth = () => {
  const { auth } = StoreContainer.store.getState();
  return auth;
};

export default {
  getAuth,
};
